import { useCallback } from 'react';
import { useDashboardModals } from 'framework/ui/dashboard';
import { DashboardModalTypes } from 'domain/shared/core/dashboard';
import { useEmployeeDashboardModals } from './useEmployeeDashboardModals';
import { DashboardEmployee, RetentionRiskFollowUp } from '../types';

export const useEmployeeDashboardActions = () => {
  const { openModal } = useDashboardModals();
  const { setFollowUpForUpdate } = useEmployeeDashboardModals();

  const handleManageIssues = useCallback(
    (employeeData?: DashboardEmployee, targetZone?: string) => {
      openModal(DashboardModalTypes.ISSUES, { employeeData, targetZone });
    },
    [openModal],
  );

  const handleAddFollowUp = useCallback(
    (followUpForUpdate?: RetentionRiskFollowUp) => {
      if (followUpForUpdate) {
        setFollowUpForUpdate(followUpForUpdate);
      }
      openModal(DashboardModalTypes.FOLLOW_UP);
    },
    [openModal, setFollowUpForUpdate],
  );

  const handleConductHealthcheck = useCallback(() => {
    openModal(DashboardModalTypes.HEALTHCHECK);
  }, [openModal]);

  const handleChangeZone = useCallback(
    (employeeData?: DashboardEmployee, targetZone?: string) => {
      openModal(DashboardModalTypes.CHANGE_ZONE, { employeeData, targetZone });
    },
    [openModal],
  );

  return {
    handleManageIssues,
    handleAddFollowUp,
    handleConductHealthcheck,
    handleChangeZone,
  };
};
